import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const fileStart = (accessToken, data) => baseAction.actionStart(actionTypes.FILE_START, accessToken, data);
export const fileSuccess = (data) => baseAction.actionSuccess(actionTypes.FILE_SUCCESS, data);
export const fileFail = (error) => baseAction.actionFail(actionTypes.FILE_FAIL, error);

export const fileSelect = (options) => {
    return (dispatch, getState) => {
        if (options && options.fileId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/File/${options.fileId}`,
                startFn: (accessToken) => dispatch(fileStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(fileSuccess({ file: response.data, isNew: false })),
                failFn: (error) => dispatch(fileFail(error))
            });
        } else {
            dispatch(fileSuccess({ file: null, isNew: true }));
        }
    };
};

export const fileList = (options) => {
    return (dispatch, getState) => {
        let url = '/File';

        if (options) {
            if (options.franchiseId) {
                url += `/Franchise/${options.franchiseId}`;
            } else if (options.mlsProviderId) {
                url += `/MlsProvider/${options.mlsProviderId}`;
            }
        }
    
        baseAction.actionExecute(dispatch, getState, {
            url: url,
            startFn: (accessToken) => dispatch(fileStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(fileSuccess({ files: response.data })),
            failFn: (error) => dispatch(fileFail(error))
        });
    };
};

export const fileCreate = (options) => {
    return (dispatch, getState) => {
        let url = '/File';

        if (options) {
            if (options.franchiseId) {
                url += `/Franchise/${options.franchiseId}`;
            } else if (options.mlsProviderId) {
                url += `/MlsProvider/${options.mlsProviderId}`;
            }
        }

        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            url: url,
            payload: options.data,
            startFn: (accessToken) => dispatch(fileStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(fileSuccess({ file: response.data, isNew: false })),
            failFn: (error) => dispatch(fileFail(error))
        });
    };
};

export const fileUpdate = (options) => {  
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            url: `/File/${options.fileId}`,
            payload: options.data,
            startFn: (accessToken) => dispatch(fileStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(fileSuccess({ file: response.data, isNew: false })),
            failFn: (error) => dispatch(fileFail(error))
        });
    };
};

export const fileDelete = (options) => {
    return (dispatch, getState) => {
        let url = '/File';

        if (options) {
            if (options.franchiseId) {
                url += `/Franchise/${options.franchiseId}/${options.fileId}`;
            } else if (options.mlsProviderId) {
                url += `/MlsProvider/${options.mlsProviderId}/${options.fileId}`;
            }
        }

        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: url,
            startFn: (accessToken) => dispatch(fileStart(accessToken, { lastScope: 'delete' })),
            successFn: (response) => dispatch(fileSuccess({ file: null, isNew: false })),
            failFn: (error) => dispatch(fileFail(error))      
        });
    };
};
